import React from 'react';

import styles from './ColorControlsModal.scss';

export const Pointer = () => {
  return <div className={styles.pointer} />;
};
